<script>
import Tag from '@/components/Tag.vue';

export default {
  name: 'MemberProfile',
  props: {
    name: String,
    nickname: String,
    occupation: String,
    photo: String,
    description: String,
    favourite: Array,
    contacts: Object,
    light: Boolean,
    centered: Boolean,
  },
  components: {
    Tag,
  },
};
</script>

<template>
  <div :class="{'team-member': true, 'team-member_light': light, 'team-member_centered': centered}">
    <img :src="photo" class="photo" v-if="photo">
    <div class="about">
      <div class="name" v-if="name">
        {{name}}
      </div>
      <div class="occupation" v-if="occupation">
        {{occupation}}
      </div>
      <div class="description">{{description}}</div>
      <template v-if="favourite">
        <div class="title">Любимые технологии и штуки</div>
        <div class="favourite">
          <div class="favourite__tag" v-for="tag in favourite" v-bind:key="tag.text">
            <Tag v-bind="tag" :dark="light"/>
          </div>
        </div>
      </template>
      <div class="contacts" v-if="contacts && Object.keys(contacts).length">
        <div v-if="contacts.vk" class="contacts__contact">
          <i class="fab fa-vk"/>
          <a class="contacts__link" :href="'//' + contacts.vk">{{contacts.vk}}</a>
        </div>
        <div v-if="contacts.email" class="contacts__contact">
          <i class="fas fa-at"/>
          <a class="contacts__link" :href="'mailto:' + contacts.email">{{contacts.email}}</a>
        </div>
        <div v-if="contacts.website" class="contacts__contact">
          <i class="fas fa-link"/>
          <a class="contacts__link" :href="'//' + contacts.website">{{contacts.website}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .team-member {
    color: var(--main-dark);
    font-weight: bold;
    display: flex;
    flex-direction: column;
  }

  .team-member_light {
    color: var(--main-bright);
  }

  $photo-size: 233px;
  .photo {
    width: $photo-size;
    height: $photo-size;
  }

  .about {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px 0;
    max-width: 500px;
  }

  .team-member_centered {
    text-align: center;

    .photo {
      margin: auto;
    }

    .about {
      align-items: center;
    }
  }

  .name {
    font-size: var(--font-size-m);
  }

  .occupation {
    margin-top: 8px;
    font-size: var(--font-size-s);
    max-width: 320px;
  }

  .nickname {
    margin-top: 14px;
    font-size: var(--font-size-s);
  }

  .description {
    margin-top: 24px;
    font-size: var(--font-size-xs);
    font-weight: normal;
    line-height: 1.7;
    white-space: pre-wrap;
  }

  .title {
    margin-top: 24px;
    font-size: var(--font-size-xs);
  }

  $tag-margin: 8px;
  .favourite {
    margin-top: 8px;

    margin-left: -$tag-margin;

    &__tag {
      margin-left: $tag-margin;
      display: inline-block;
      margin-bottom: 8px;
    }
  }

  .contacts {
    margin-top: 16px;
    padding: 8px 24px 24px;
    background-color: var(--main-dark);
    color: var(--main-bright);
    font-size: var(--font-size-m);

    &__contact {
      margin-top: 16px;
      display: flex;
      align-items: center;
    }

    &__link {
      margin-left: 16px;
      color: var(--main-bright);
      font-weight: normal;
      font-size: var(--font-size-xs);
    }
  }
</style>
